<template>
    <v-card
        :ripple="false"
        @click = "onSelectd"
        flat
    >
        <div style="height: 25px" >
            <div class="v-flex w-100">
                <div style="margin-top: -2px; margin-right: -10px;" class="mr-1">
                    <c-site-icon
                        :site="unit"
                        @selected="onSite"
                    />
                </div>
                <div class="v-flex" style="width: calc(100% - 25px)">
                    <div
                        class="mr-1 unit-name"
                        style="min-width: 120px"
                        :class="active ? '' : 'lightgray'"
                    >
                        {{ unit.fabricNo }}
                    </div>
                    <div
                        class="unit-location"
                        :class="active ? '' : 'lightgray'"
                    >
                        {{ unit.city }}, {{ unit.street }}
                    </div>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
import CSiteIcon from "@/modules/msd/unit/components/controlls/CSiteIcon.vue";
import Core from "@/modules/core/service/Core";

export default {
    name: "PDmsTreeviewUnitEntry",

    components: {
        CSiteIcon
    },

    props: {
        unit: {

        }
    },

    computed: {
        active () {
            if (!this.unit.status) {
                return false;
            }

            return this.unit.status.id === 1;
        },
    },

    methods: {
        onSelectd () {
            return Core.fire.selected(this, this.unit);
        },

        onSite () {
            this.$emit("site", this.unit)
        },

        date (value) {
            return Core.format.date.display(value);
        },
    }
}
</script>

<style scoped>

::v-deep .toolbar-button {
    padding: 0px;
    width: 25px;
    height: 25px;
}

.unit-name, .unit-location {
    font-size: 15px;
    padding-top: 1px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.unit-name {
    max-width: 120px;
    min-width: 120px
}

.unit-location {
    max-width: calc(100% - 125px);
}

</style>